import React from 'react';
import { AccountAllowanceEntryType } from './AccountAllowanceTypes';

function AccountAllowanceEntry(props: AccountAllowanceEntryType) {
	return (
		<div className={`user-account-allowance-stat-container ${props.small ? 'small-allowance' : ''}`}>
			<div className='user-account-allowance-stat-title'>{props.title}</div>
			<div className='user-account-allowance-stat-figure'>{props.figure}</div>
			<div className='user-account-allowance-stat-footer'>{props.footer}</div>
		</div>
	);
}

export { AccountAllowanceEntry };
